// extracted by mini-css-extract-plugin
export var banner = "_tb-0";
export var settingRow = "_tb-2";
export var titleIcon = "_tb-1";